package uz.ferro.erp.feature.menu.ui

import mui.material.IconButton
import mui.system.sx
import react.FC
import react.Props
import uz.ferro.erp.Colors
import uz.ferro.erp.feature.menu.model.MenuItem
import uz.ferro.erp.ui.AppTextMedium
import uz.ferro.erp.ui.HorizontalLayout
import web.cssom.AlignItems
import web.cssom.Cursor
import web.cssom.None
import web.cssom.px

external interface MenuItemProps : Props {
    var item: MenuItem
}

val ToolbarMenuItem = FC<MenuItemProps> { props ->
    val item = props.item
    HorizontalLayout {
        sx {
            alignItems = AlignItems.center
            cursor = Cursor.pointer
        }

        if (item.title.isNullOrBlank().not()) {
            onClick = { item.action() }
        }

        if (item.icon != null) {
            IconButton {
                item?.icon?.invoke {
                    sx {
                        color = Colors.accentContrastColor
                    }
                }
            }
        }

        if (item.title != null) {
            AppTextMedium {
                text = item.title
                color = Colors.accentContrastColor
                sx {
                    userSelect = None.none
                }
            }
        }
    }
}